class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
    this.hoverTimeout = null;
    
    // Add hover functionality for desktop
    if (this.isDesktop) {
      this.setupHover();
    }
  }

  setupHover() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    
    // Mouse enter - open menu
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverTimeout);
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
      if (this.header) {
        this.header.preventHide = true;
      }
    });

    // Mouse leave - close menu with slight delay to allow moving to content
    this.addEventListener('mouseleave', (e) => {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = setTimeout(() => {
        // Check if mouse is still not over the menu
        if (!this.matches(':hover')) {
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.mainDetailsToggle.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
          if (this.header) {
            this.header.preventHide = false;
          }
        }
      }, 100);
    });

    // Also handle mouse leave on content
    if (this.content) {
      this.content.addEventListener('mouseleave', () => {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => {
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.mainDetailsToggle.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
          if (this.header) {
            this.header.preventHide = false;
          }
        }, 100);
      });
    }

    // Prevent default click behavior on desktop for mouse clicks only (keep keyboard navigation)
    summary.addEventListener('click', (e) => {
      if (this.isDesktop && e.detail > 0) {
        // e.detail > 0 means it's a mouse click, not keyboard
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    
    // Handle animations
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
    
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
